const regexGuid = /^[\da-f]{8}-[\da-f]{4}-[1-5][\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;
const regexClean = /[\s/{}]+/gi;

export function isValidGuid(value?: string): boolean {
    if (!value) {
        return false;
    }

    return regexGuid.test(value.replaceAll(regexClean, ""));
}
